import * as yup from 'yup';

const schema = yup.object({
  id: yup.string().label('id'),
  partnerId: yup.string().required('Partner é obrigatório'),
  productId: yup.string().required('Produto é obrigatório'),
  product_tier: yup.number().required('Tier é obrigatório'),
  sellerId: yup.string().required('Vendedor é obrigatório'),
  dollarType: yup.string().required('Dollar é obrigatório'),
  dollarValue: yup.number().when(['dollarType'], {
    is: (val: string) => val === 'PTAX',
    then: () => yup.number().notRequired(),
    otherwise: () => yup.number().required('Valor do dollar é obrigatório').min(0.1).max(100),
  }),
  taxes: yup.array().required('Impostos são obrigatórios'),
  dueDates: yup.number().required('Dia de pagamento é obrigatório'),
  paymentType: yup.string().required('Tipo de pagamento é obrigatório').default('BOLETO ITAÚ'),
  currency: yup.string().required('Moeda é obrigatória').oneOf(['BRL', 'USD'], 'Moeda deve ser BRL ou USD'),
  credit: yup.array().notRequired(),
  freeUntil: yup.string().notRequired().nullable(),
  mmcFreeUntil: yup.string().notRequired().nullable(),
  notificationEmails: yup.array().of(yup.string().email('E-mail inválido')).required('E-mails para notificações são obrigatórios'),
});

export default schema;
